import React from 'react';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../stores/ToastStore';
import {
  useHandleDeleteDocuments,
  useRetryUploadDocuments,
} from '../../../utils/DocumentsHooks';

export function FailedDocument({ document, onDelete }) {
  const { t } = useTranslation();
  const [retryUploadDocuments] = useRetryUploadDocuments();
  const { handleDelete } = useHandleDeleteDocuments(() => {
    onDelete?.(document);
  });

  const handleRetryUpload = (documentId) => {
    const retryResult = retryUploadDocuments([documentId]);
    if (retryResult.error) {
      showToast(
        t('GET_DOCUMENT_ERROR'),
        t('GET_DOCUMENT_FAILED_WITH_ERROR', { error: retryResult.error }),
        'error',
      );
    }
  };

  return (
    <div className="flex flex-col relative">
      <div className="flex justify-center align-middle mb-4">
        <i className="icon glyphicon glyphicon-alert text-orange" />
        <span>{t('DOCUMENT_UPLOAD_FAILED_RETRY')}</span>
      </div>
      <button
        type="button"
        className="button button-hollow-red"
        onClick={handleRetryUpload(document.id)}
      >
        {t('RETRY_UPLOAD')}
      </button>
      <i
        className="icon glyphicon glyphicon-remove text-red cursor-pointer -top-2 -right-2 absolute"
        onClick={() => handleDelete([document])}
      />
    </div>
  );
}
